module.exports = __webpack_public_path__ + "static/media/scmh-logo.4fb8e8da.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/scmh-logo.svg
// module id = 1324
// module chunks = 0